import React from 'react';
import { Box, Container, Typography, Grid, Button, Card, CardHeader, CardContent, Chip, Stack } from '@mui/material';
import Security from '@mui/icons-material/Security';
import CloudQueue from '@mui/icons-material/CloudQueue';
import LanIcon from '@mui/icons-material/Lan';
import CheckCircle from '@mui/icons-material/CheckCircle';
import ArrowRightAlt from '@mui/icons-material/ArrowRightAlt';

const Section = ({ id, children, sx = {} }) => (
  <Box id={id} sx={{ py: { xs: 6, md: 8 }, ...sx }}>
    <Container maxWidth="lg">{children}</Container>
  </Box>
);

const Item = ({ text }) => (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1 }}>
    <CheckCircle sx={{ fontSize: 18, mt: '2px', color: 'success.main' }} />
    <Typography variant="body2">{text}</Typography>
  </Box>
);

export default function TechIntegration() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      {/* HERO */}
      <Section>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={7}>
            <Chip label="Custom, Secure, Scalable" color="primary" variant="outlined" sx={{ borderRadius: 2 }} />
            <Typography variant="h3" fontWeight={700} sx={{ mt: 2 }}>Technology & Integration</Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mt: 2 }}>
              We design and implement custom, secure solutions tailored to your environment. Through strategic partnerships we deliver scalable, world‑class platforms that are reliable and compliant.
            </Typography>
            <Stack direction="row" spacing={1.5} sx={{ mt: 3, flexWrap: 'wrap' }}>
              <Button variant="contained" endIcon={<ArrowRightAlt />}>Talk to us</Button>
              <Button variant="outlined">See use cases</Button>
            </Stack>
          </Grid>
          <Grid item xs={12} md={5}>
            <Card sx={{ borderRadius: 3 }}>
              <CardHeader title="What we deliver" />
              <CardContent sx={{ display: 'grid', gap: 1.25 }}>
                <Item text="Secure messaging & chatbot integrations (WhatsApp, SMS)" />
                <Item text="Identity & access with role‑based controls" />
                <Item text="Cloud‑first deployments with monitoring & backups" />
                <Item text="Analytics pipelines and reporting dashboards" />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Section>

      {/* FEATURES */}
      <Section>
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: 2 }}>
              <CardHeader avatar={<Security color="primary" />} title="Security by design" />
              <CardContent>
                <Typography variant="body2" color="text.secondary">Encryption, audit trails, and data protection aligned to Kenya’s DPA and global best practices.</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: 2 }}>
              <CardHeader avatar={<CloudQueue color="primary" />} title="Cloud & telecom partners" />
              <CardContent>
                <Typography variant="body2" color="text.secondary">We integrate with major cloud providers to ensure reliability, scale, and cost efficiency.</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={12} md={4}>
            <Card sx={{ borderRadius: 2 }}>
              <CardHeader avatar={<LanIcon color="primary" />} title="Tailored to your stack" />
              <CardContent>
                <Typography variant="body2" color="text.secondary">APIs, data connectors, and UI components that fit your current systems and processes.</Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Section>
    </Box>
  );
}
